<template>
  <v-layout
    v-if="family !== null"
    wrap
  >
    <v-flex xs12>
      <v-layout
        class="mt-4 pa-3"
        :class="{ sz_background_light: isCurrentEdition }"
        wrap
      >
        <v-flex
          xs12
          class="mb-3"
        >
          <h2 class="display-3">
            {{ $t('preview.family_description.title') }}
          </h2>
          <router-link
            :disabled="readOnly"
            :class="{ disabled: readOnly }"
            :to="{ name: 'family-description', params: { familyId: $route.params.familyId } }"
          >
            {{ $t('buttons.edit_description') }}
          </router-link>
        </v-flex>
        <v-flex xs12>
          <v-layout wrap>
            <FamilyMember
              v-for="(person, index) in family.familyMembers"
              :key="index"
              :person="person"
            />
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      class="mt-4"
    >
      <h3 class="display-2 mb-1">
        {{ $t('description.family_history.title') }}
      </h3>
      <p class="f-1 mb-0 formatted-text">
        {{ family.sheet.description.familyHistory }}
      </p>
    </v-flex>
    <v-flex
      xs12
      class="mt-4 pa-3 bordered__gray"
    >
      <h3 class="display-2 mb-1">
        <BaseIcon>
          <BeautyIcon :icon-color="$vuetify.theme.sz_light_grey" />
        </BaseIcon>
        {{ $t('description.family_everyday_life.title') }}
      </h3>
      <p
        v-if="family?.sheet?.description?.familyBeauty"
        class="f-1 mb-0 formatted-text"
      >
        {{ family.sheet.description.familyBeauty }}
      </p>
      <p
        v-if="family?.sheet?.description?.familyEverydayLife"
        class="f-1 mb-0 formatted-text"
      >
        {{ family.sheet.description.familyEverydayLife }}
      </p>
    </v-flex>
    <v-flex
      xs12
      class="mt-4"
    >
      <div class="pa-3 bordered__red">
        <h3 class="display-2 mb-1 required-block">
          <BaseIcon>
            <PaczkopediaIcon :icon-color="$vuetify.theme.sz_light_grey" />
          </BaseIcon>
          {{ $t('preview.family_description.important_needs') }}
        </h3>
        <ul class="f-16 ul-decimal">
          <li
            v-for="(need, index) in family.formattedNeeds.importantNeeds.list"
            :key="index"
          >
            <p class="mb-1 fw-600 formatted-text">
              {{ need.need }}
            </p>
            <p class="formatted-text">
              {{ need.note }}
            </p>
          </li>
        </ul>
      </div>
      <p class="f-16 fw-600 required-block required-block_left mt-2 mb-0">
        {{ $t('preview.family_description.important_needs_hint') }}
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import FamilyMember from '@/components/previewForDonor/FamilyMember';
import BaseIcon from '@/icons/BaseIcon';
import BeautyIcon from '@/icons/BeautyIcon';
import PaczkopediaIcon from '@/icons/PaczkopediaIcon';

export default {
    name: 'FamilyDescription',
    components: { FamilyMember, BaseIcon, BeautyIcon, PaczkopediaIcon },
    props: {
        readOnly: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        family () {
            return this.$store.getters['previewForDonor/getPreviewInfo'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    }
};
</script>

<style scoped></style>
